/* eslint-disable no-unused-vars */
import { css, StyleSheet } from 'aphrodite'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import api from '../../api'
import UIButton from '../../components/UI/UIButton'
import { COLOR_WHITE, COLOR_BLACK } from '../../lib/colors'
import { Auth } from 'aws-amplify'
import LiveContext from '../../components/Context/LiveContext'

const styles = StyleSheet.create({
  container: {
    padding: '16px',
    height: '100%',
    '@media (max-width: 1024px)': {
      padding: 0,
    },
  },
  detailContainer: {
    backgroundColor: COLOR_WHITE,
    borderRadius: '10px',
    paddingBottom: '20px',
    padding: '30px',
    width: '40%',
    height: '100%',
    '@media (max-width: 1024px)': {
      width: '100%',
      margin: 0,
      padding: '15px',
    },
  },
  title: {
    fontWeight: 600,
    fontSize: '28px',
    marginBottom: '37px',
    lineHeight: '14px',
    '@media (max-width: 1024px)': {
      fontSize: '20px',
    },
  },
  subtitle: {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '14px',
  },
  description: {
    fontWeight: 700,
    fontSize: '14px',
    marginBottom: '39px',
    lineHeight: '14px',
  },
  question: {
    fontSize: '14px',
  },
  descriptionContainer: {
    width: '75%',
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  modalContainer: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '263px',
  },
  buttonConfirmationContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  modalTitle: {
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '24px',
    color: COLOR_BLACK,
    textAlign: 'center',
  },
  modalDescription: {
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '12px',
    color: COLOR_BLACK,
    textAlign: 'center',
  },
  buttonDynamicStyle: {
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
  },
  buttonShowModal: {
    '@media (max-width: 1024px)': {
      width: '100%',
      marginTop: '30px',
      height: '34px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '20px',
    },
  },
})

const DeleteAccountModal = () => {
  const { t } = useTranslation('deleteAccount')
  const navigate = useNavigate()

  const { setUserLogged } = useContext(LiveContext)

  const logOut = () => {
    Auth.signOut({ global: true }).then(() => {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      setUserLogged(false)
      navigate('/')
    })
  }

  const deleteAccount = async () => {
    try {
      const response = await api.apiDelete('/me')
      console.log('response : ', response)
      switch (response?.error_code) {
        case 'ANO11':
          toast.error(t('unpaidInvoice'), {
            autoClose: 8000,
          })
          break
        case 'ANO12':
          toast.error(t('requestToDo'), {
            autoClose: 8000,
          })
          break
        case 'ANO13':
          toast.error(t('pendingRequests'), {
            autoClose: 8000,
          })
          break
        case 'ANO21':
        case 'ANO22 ':
          toast.error(t('serverError'), {
            autoClose: 8000,
          })
          break
        default:
          toast.success(t('successMessage'))
          logOut()
          break
      }
    } catch (error) {
      toast.error(t('serverError'), {
        autoClose: 5000,
      })
      console.log('delete account error : ', error)
    }
  }

  return (
    <div className={css(styles.modalContainer)}>
      <h1 className={css(styles.modalTitle)}>{t('modalTitle')}</h1>
      <p className={css(styles.modalDescription)}>{t('modalDescription')}</p>
      <div className={css(styles.buttonConfirmationContainer)}>
        <UIButton
          dynamicStyle={styles.buttonDynamicStyle}
          label={t('deleteButtonLabel')}
          design="primary"
          onClick={deleteAccount}
        />
        <UIButton
          dynamicStyle={styles.buttonDynamicStyle}
          label={t('cancel')}
          design="invertedPrimary"
          onClick={() => toast.dismiss()}
        />
      </div>
    </div>
  )
}

export default function DeleteAccount() {
  const { t } = useTranslation('deleteAccount')

  const handleDeleteAccount = () => {
    toast(<DeleteAccountModal />, {
      autoClose: false,
      limit: 0,
    })
  }

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.detailContainer)}>
        <div className={css(styles.descriptionContainer)}>
          <h1 className={css(styles.title)}>{t('title')}</h1>
          <p className={css(styles.subtitle)}>{t('subTitle')} </p>
          <p className={css(styles.description)}>{t('description')} </p>
          <p className={css(styles.question)}>{t('question')}</p>
        </div>
        <div className={css(styles.buttonContainer)}>
          <UIButton
            onClick={handleDeleteAccount}
            label={t('buttonLabel')}
            design="tertiaryLight"
            dynamicStyle={styles.buttonShowModal}
          />
        </div>
      </div>
    </div>
  )
}
